export const STAGE_ACCENT = {
  intake:    '#6366f1',
  diagnosis: '#f59e0b',
  repair:    '#3b82f6',
  verify:    '#8b5cf6',
  complete:  '#22c55e',
};

// Primary action for each status
export const PRIMARY_ACTION = {
  yard:         { label: 'Start Diagnosis →',   nextStatus: 'waiting' },
  triage:       { label: 'Move to Repair →',     nextStatus: 'wip' },    // backward compat
  waiting:      { label: 'Move to Repair →',     nextStatus: 'wip' },
  approval:     { label: 'Start Repair →',       nextStatus: 'wip' },
  'parts-auth': { label: 'Start Repair →',       nextStatus: 'wip' },
  parts:        { label: 'Start Repair →',       nextStatus: 'wip' },
  'parts-hold': { label: 'Start Repair →',       nextStatus: 'wip' },
  wip:          { label: 'Send to Road Test →',  nextStatus: 'road-test' },
  'road-test':  { label: 'Mark Complete →',      nextStatus: 'done' },
  qc:           { label: 'Mark Complete →',      nextStatus: 'done' },   // backward compat
  done:         { label: 'Close RO',             action: 'complete' },
};

// Secondary actions
export const SECONDARY_ACTIONS = {
  yard:        [{ label: 'Request Auth',       nextStatus: 'approval' }],
  triage:      [{ label: 'Request Auth',       nextStatus: 'approval' }],
  waiting:     [{ label: 'Request Auth',       nextStatus: 'approval' }],
  'road-test': [{ label: '↩ Back to Repair',   nextStatus: 'wip' }],
  qc:          [{ label: '↩ Back to Repair',   nextStatus: 'wip' }],
  done:        [{ label: '↩ Back to Road Test', nextStatus: 'road-test' }],
};

export const CATEGORY_OPTIONS = [
  'Aftertreatment', 'Brakes', 'Cooling System', 'Electrical', 'Engine',
  'Exhaust', 'Frame / Body', 'Fuel System', 'HVAC', 'Hydraulics',
  'PM Service', 'Suspension / Steering', 'Tires / Wheels', 'Transmission', 'Other',
];

export const PART_STATUSES = [
  { value: 'pending',     label: 'Pending',     color: '#64748b', bg: '#f1f5f9' },
  { value: 'ordered',     label: 'Ordered',     color: '#2563eb', bg: '#eff6ff' },
  { value: 'backordered', label: 'Backordered', color: '#d97706', bg: '#fef3c7' },
  { value: 'received',    label: 'Received',    color: '#16a34a', bg: '#dcfce7' },
  { value: 'returned',    label: 'Returned',    color: '#dc2626', bg: '#fee2e2' },
];

export function getPartStatus(status) {
  return PART_STATUSES.find(s => s.value === status) ?? PART_STATUSES[0];
}
